import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const bookingsAPI = createApi({
    reducerPath: "bookingsAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllVendorsWithoutBookings: builder.mutation({
            query: ({ page, size, search }) => {
                let apiUrl = `/admin/bookings/reports/zero-booking-vendors?page=${page + 1}&size=${size}`;

                if (search) {
                    apiUrl += `&searchTerm=${search}`;
                }
                
                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["vendorWithoutBookings"],
        }),
        getALLBookings:builder.mutation({
            query: ({page, limit, searchTerm, status}) => {
                let apiUrl = `admin/bookings?page=${page + 1}&size=${limit}`;

                if (searchTerm) {
                apiUrl += `&searchTerm=${searchTerm}`;
                }

                if (status) {
                apiUrl += `&status=${status}`;
                }

                return {
                url: apiUrl,
                method: 'GET',
                };
            },
            transformResponse: (response) => response,
            providesTags: ["vendorWithBookings"],
        }),
        getBookingById: builder.mutation({
            query: ({ id }) => ({
                url: `admin/bookings/${id}`,
                method: 'GET',
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['vendorWithBookings'],
        }),
        updateBooking: builder.mutation({
            query: ({ id, body }) => ({
                url: `admin/bookings/${id}`,
                method: 'PATCH',
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['vendorWithBookings'],
        }),

        cancelBooking: builder.mutation({
            query: ({ id, body }) => ({
                url: `admin/bookings/${id}/cancel`,
                method: 'POST',
                body,
            }),
            ransformResponse: (response) => response,
            invalidatesTags: ['vendorWithBookings'],
        }),

        // ====================================================================
        // INSIGHTS
        // ====================================================================
        getToursInsights: builder.query({
            query: ({ startDate, endDate }) => {
                let apiUrl = `admin/bookings/tours/insights`;
                if (startDate) {
                    apiUrl += `?startDate=${startDate}`;
                }
                if (endDate) {
                    apiUrl += `${startDate ? '&' : '?'}endDate=${endDate}`;
                }
                return {
                    url: apiUrl,
                    method: 'GET',
                };
            },
            transformResponse: (response) => response.data,
            providesTags: ['toursInsights'],
        }),

        getBookingsInsights: builder.query({
            query: ({ startDate, endDate }) => {
                let apiUrl = `admin/bookings/insights`;
                if (startDate) {
                    apiUrl += `?startDate=${startDate}`;
                }
                if (endDate) {
                    apiUrl += `${startDate ? '&' : '?'}endDate=${endDate}`;
                }
                return {
                    url: apiUrl,
                    method: 'GET',
                };
            },
            transformResponse: (response) => response.data,
            providesTags: ['bookingsInsights'],
        }),
    }),
});

export const { 
    useGetAllVendorsWithoutBookingsMutation,
    useGetALLBookingsMutation,
    useGetBookingByIdMutation,
    useUpdateBookingMutation,

    useCancelBookingMutation,

    // Insights
    useGetBookingsInsightsQuery,
    useGetToursInsightsQuery,
} = bookingsAPI;

export default bookingsAPI;